import { QuizQuestion } from "../models/quiz/QuizQuestionModel";
import { QuizCategory } from "../models/quiz/QuizCategoryModel";

const presentAndPresentPerfectQuestions: QuizQuestion[] = [
    {
        category: QuizCategory.PRESENT,
        questionText: "Elige la forma correcta del verbo en presente: 'Cada día yo ___ (comer) frutas.'",
        options: ["comen", "coméis", "como", "comen"],
        correctAnswerIndex: 2,
        explanation: "'Como' es la forma del verbo 'comer' para la primera persona singular en presente."
    },
    {
        category: QuizCategory.PRESENT,
        questionText: "Completa la oración: 'Nosotros ___ (trabajar) en la oficina los lunes.'",
        options: ["trabajáis", "trabajan", "trabajo", "trabajamos"],
        correctAnswerIndex: 3,
        explanation: "'Trabajamos' es la forma del verbo 'trabajar' para la primera persona plural en presente."
    },
    {
        category: QuizCategory.PRESENT,
        questionText: "Selecciona la opción correcta: 'Ella ___ (vivir) en Madrid.'",
        options: ["vive", "vivo", "vivimos", "vivís"],
        correctAnswerIndex: 0,
        explanation: "'Vive' es la forma del verbo 'vivir' para la tercera persona singular en presente."
    },
    {
        category: QuizCategory.PRESENT,
        questionText: "Estamos ___ al parque",
        options: ["yendo", "ir", "vamos", "fue"],
        correctAnswerIndex: 0,
        explanation: "El gerundio del verbo 'ir' es 'yendo'."
    },
    {
        category: QuizCategory.PRESENT,
        questionText: "Elige la forma correcta: 'Yo ___ (comer) pizza esta semana.'",
        options: ["he comía", "he comido", "comí", "como"],
        correctAnswerIndex: 1,
        explanation: "'He comido' es el presente perfecto, que se utiliza para hablar de acciones que han ocurrido en un tiempo reciente y tienen relevancia en el presente."
    },
    {
        category: QuizCategory.PRESENT,
        questionText: "Completa la frase: 'Ellos ___ (hacer) ejercicio todos los días.'",
        options: ["han hecho", "hacen", "hizo", "hacerán"],
        correctAnswerIndex: 1,
        explanation: "El verbo hacer está conjugado en presente del indicativo para el sujeto ellos."
    },
    {
        category: QuizCategory.PRESENT,
        questionText: "Selecciona la opción correcta: '¿Tú ___ (ver) la película que te recomendé?'",
        options: ["has ver", "viste", "has visto", "verás"],
        correctAnswerIndex: 2,
        explanation: "'Has visto' es el presente perfecto, usado para referirse a una acción completada en el pasado pero que tiene relevancia en el presente."
    },
    {
        category: QuizCategory.PRESENT,
        questionText: "Yo estoy ___ un libro ahora.",
        options: ["leyendo", "leer", "leyó", "lee"],
        correctAnswerIndex: 0,
        explanation: "'Leyendo' es la forma en gerundio del verbo 'leer'."
    },
    {
        category: QuizCategory.PRESENT,
        questionText: "Selecciona la opción correcta: 'Yo ___ (leer) mucho últimamente.'",
        options: ["lee", "leo", "leí", "he leído"],
        correctAnswerIndex: 1,
        explanation: "'Leo' es la forma correcta en presente para la primera persona singular del verbo 'leer'."
    },
    {
        category: QuizCategory.PRESENT,
        questionText: "Completa la oración: 'Mis amigos siempre ___ (ir) al gimnasio después del trabajo.'",
        options: ["van", "voy", "fue", "irán"],
        correctAnswerIndex: 0,
        explanation: "'Van' es la forma correcta en presente para la tercera persona plural del verbo 'ir'."
    },
    {
        category: QuizCategory.PRESENT,
        questionText: "Elige la forma correcta: 'Nosotros ___ (hablar) español y francés.'",
        options: ["habláis", "hablan", "hablamos", "hablaba"],
        correctAnswerIndex: 2,
        explanation: "'Hablamos' es la forma correcta para la primera persona plural del verbo 'hablar'."
    },
    {
        category: QuizCategory.PRESENT,
        questionText: "Completa la frase: 'Ellos ___ (trabajar) mucho esta semana para terminar el proyecto.'",
        options: ["han trabajado", "trabajan", "trabajaron", "trabajaban"],
        correctAnswerIndex: 0,
        explanation: "'Han trabajado' es el presente perfecto del verbo 'trabajar', usado para expresar una acción completada en un tiempo reciente."
    },
    {
        category: QuizCategory.PRESENT,
        questionText: "Selecciona la opción correcta: 'Nosotros ___ (visitar) varios países este año.'",
        options: ["visitamos", "visitamos", "visitaron", "hemos visitado"],
        correctAnswerIndex: 3,
        explanation: "'Hemos visitado' es la forma correcta del presente perfecto en primera persona plural, que indica una acción pasada con relevancia en el presente."
    },
    {
        category: QuizCategory.PRESENT,
        questionText: "Elige la opción correcta: '¿Tú ___ (estudiar) este material todos los días?'",
        options: ["estudias", "has estudiado", "estudiabas", "estudiaste"],
        correctAnswerIndex: 0,
        explanation: "'Todos los días' es un indicador de tiempo que representa una acción habitual."
    }
];

export default presentAndPresentPerfectQuestions;
